import React from 'react';
import * as S from './styles';

import type { Props as ClickableProps } from 'src/components/clickable';

type Props = {
  categoryImage: string;
  categoryName: string;
  brandLogo?: string;
  brandName: string;
};

export const BrandCategoryCard = ({
  categoryImage,
  categoryName,
  brandLogo,
  brandName,
  ...clickableProps
}: Props & ClickableProps) => (
  <S.Card {...clickableProps}>
    <S.CategoryLogo src={categoryImage} alt={categoryName} />
    {brandLogo && <S.BrandLogo src={brandLogo} alt={brandName} />}
    <S.BrandName>{brandName}</S.BrandName>
    <S.CategoryName>{categoryName}</S.CategoryName>
  </S.Card>
);
